import { COLORS } from './colors';

export const DIGIT_SEPARATION = {
  THOUSAND: ',3',
  NONE: '',
} as const;

export type TDigitalSeparation =
  (typeof DIGIT_SEPARATION)[keyof typeof DIGIT_SEPARATION];

export const REQUIRED_ERROR =
  'This is a required field and can not be left blank';

export type WhiteLabellingConfig = {
  faviconURL: string;
  logoURL: string;
  navBarBackgroundColor: string;
  navBarFontColor: string;
  uiControlBackgroundColor: string;
  uiControlFontColor: string;
  showCheckboxBranding?: boolean;
};

export const defaultWhiteLabelling: WhiteLabellingConfig = {
  logoURL: 'https://static.checkbox.ai/_global/Checkbox-Logo-Inverse.svg',
  faviconURL: 'https://static.checkbox.ai/_global/Checkbox-Favicon.ico',
  navBarBackgroundColor: COLORS.MEDIUM_BLUE,
  navBarFontColor: COLORS.WHITE,
  uiControlBackgroundColor: COLORS.GREEN,
  uiControlFontColor: COLORS.WHITE,
};

export interface IOption {
  label: string;
  value: string;
  tempId: string;
}

export interface DropdownValue {
  label: string;
  value: string;
}

/**
 * Input properties/names of the field editor form.
 */
export const fieldProperties = {
  NAME: { value: 'name', label: 'Field Name*' },
  VALIDATION: { value: 'validation', label: 'Field Validation' },
  MAX_CHARACTERS: { value: 'maxCharacters', label: 'Number of Characters' },
  REGEX_PATTERN: { value: 'regexPattern', label: 'Regular Expression Pattern' },
  REGEX_ERROR_MESSAGE: {
    value: 'regexErrorMessage',
    label: 'Validation Error Message',
  },
  DEFAULT_VALUE: { value: 'defaultValue', label: 'Default Value*' },
  REQUIRED: { value: 'required', label: 'Required' },
  NUMBER_FORMAT: { value: 'numberFormat' },

  OPTIONS: { value: 'options' },
  DATE_FORMAT: { value: 'dateFormat', label: 'Formatting' },
  FILE_TYPES: { value: 'fileTypes', label: 'File Types' },
  USER_GROUP: { value: 'userGroup', label: 'User Group To Pick From' },
  CUSTOM: { value: 'custom', label: 'Custom' },
  LIST_TYPE: { value: 'listType', label: 'List Type' },
};

export type User = {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
};

export interface BoardMember extends Omit<User, 'id'> {
  userId: number;
  id: string;
}

export const DEFAULT_FIELD_NONE_OPTION = {
  label: '--None--',
  value: '',
};
